import { Action, createFeatureSelector, createSelector } from '@ngrx/store';
import * as actions from './actions';
import { IContractStructure } from '../IContractStructure';
import { IEntityFilter } from '../IEntityFilter';
import { ICustomer } from '../ICustomer';
import { IContractType } from '../IContractType';

export interface State {
    jobs: Array<IContractStructure>;
    jobListStatus: Array<IEntityFilter>;
    customers: Array<ICustomer>;
    contractTypes: Array<IContractType>;
    errors: Array<string>;
}

export const initialState: State = {
    jobs: undefined,
    jobListStatus: undefined,
    customers: undefined,
    contractTypes: undefined,
    errors: undefined
};

export function reducer(
    state = initialState,
    action: actions.ActionsUnion
): State {
    switch (action.type) {
        case actions.ActionTypes.Reset:
            return initialState;
        case actions.ActionTypes.SetCustomerJobs:
            return {
                ...state,
                jobs: [...action.payload]
            };
        case actions.ActionTypes.SetEntityFilter:
            return {
                ...state,
                jobListStatus: [...action.payload]
            };
        case actions.ActionTypes.SetCustomers:
            return {
                ...state,
                customers: [...action.payload]
            };
        case actions.ActionTypes.SetContractTypes:
            return {
                ...state,
                contractTypes: [...action.payload]
            };
        // case actions.ActionTypes.SetUserEntryDates:
        //   return {
        //     ...state,
        //     entryDates: [...action.payload]
        //   };
        case actions.ActionTypes.UpdateContractStructureSuccess:
            const resp = action.payload;
            return {
                ...state,
                jobs: state.jobs
                    .map<IContractStructure>(
                        x =>
                            resp.Items.find(
                                y => y.QB_ListID === x.QB_ListID
                            ) || {
                                ...x
                            }
                    ) // update any existing
                    .concat(
                        resp.Items.filter(
                            x =>
                                !state.jobs.find(
                                    y => y.QB_ListID === x.QB_ListID
                                )
                        )
                    ), // add any new
                errors: resp.ErrorMessages
            };
        default:
            return state;
    }
}
const StateFeatureSelector = createFeatureSelector<State>('customerjob');
export const getContractTypes = createSelector(
    StateFeatureSelector,
    x => x.contractTypes
);
export const getCustomers = createSelector(
    StateFeatureSelector,
    x => x.customers
);
export const getEntityFilter = createSelector(
    StateFeatureSelector,
    x => x.jobListStatus
);
export const getCustomerJobs = createSelector(
    StateFeatureSelector,
    x => x.jobs
);
export const getCustomerJobErrors = createSelector(
    StateFeatureSelector,
    x => x.errors
);
